export default __webpack_public_path__ + "static/hhc-blog-1-f5e826897d9b121c6f99f47cfacae15d.png";